const mColors = {
    blue: '#109dff',
    rose: '#f06cdc',
    lightGray: '#707070',
    darkGray: '#4a4a4a',
    red: '#ff0000'
}

export default mColors;